// extracted by mini-css-extract-plugin
export default {"activityTab":"styles__activityTab___zqWSm","collaborators":"styles__collaborators___soUa2","footer":"styles__footer___l6_Wz"};